import React, { useRef, useState } from "react";
import GlonassRelayControl from "./GlonassRelayControl";

import UpdateButton from "../../shared/UpdateButton/UpdateButton";
import { TfiSaveIcon } from "../../../models/Icons.model";
import { IconButton, Tooltip, Whisper } from "rsuite";
import {GlonassRelayHandle, RelayListControlProps} from "./RelaySettings.model";

const RelayListControl = ({
  executeCommand,
  deviceId,
  onAfterTimeRelayWrite,
  dawnTime,
  duskTime,
  refreshDuskDawn
}: RelayListControlProps) => {
  const [loading, setLoading] = useState(false);

  const astronomicRelayRef = useRef<GlonassRelayHandle | null>(null);

  const handleRefresh = async () => {
    if (astronomicRelayRef.current?.refresh) {
      setLoading(true);
      try {
        await astronomicRelayRef.current.refresh();
        if (onAfterTimeRelayWrite) {
          await onAfterTimeRelayWrite();
        }
        if (refreshDuskDawn) {
          await refreshDuskDawn();
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const handleUpdate = async () => {
    if (astronomicRelayRef.current?.update) {
      setLoading(true);
      try {
        await astronomicRelayRef.current.update();
        if (onAfterTimeRelayWrite) {
          await onAfterTimeRelayWrite();
        }
        if (refreshDuskDawn) {
          await refreshDuskDawn();
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <div className="fieldset-wrapper mb-2">
        <div className="legend-title main-legend-title">Астрономическое реле</div>
        <section className="secondary-clock">
          <div className="row p-2">
            <div className="col-12 d-flex justify-content-end gap-2">
              <Whisper placement="top" speaker={<Tooltip>Сохранить</Tooltip>}>
                <IconButton
                  style={{ marginRight: "10px" }}
                  icon={<TfiSaveIcon />}
                  size="sm"
                  loading={loading}
                  onClick={handleUpdate}
                  className="refresh-btn"
                />
              </Whisper>
              <UpdateButton
                loading={loading}
                onRefresh={handleRefresh}
              />
            </div>
          </div>
          <div className="row p-2 pt-0">
            <div className="col">
              <GlonassRelayControl
                ref={astronomicRelayRef}
                deviceId={deviceId}
                dawnTime={dawnTime}
                duskTime={duskTime}
                executeCommand={executeCommand}
                onAfterWrite={onAfterTimeRelayWrite}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RelayListControl;
